import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { AWAITING_REPLY } from "MODULES/IncomingQuotes/constants";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import Form from "./Form";

function isAwaitingReply(lineItems) {
  return lineItems.some(item => item.quote_type === AWAITING_REPLY);
}

function Send({ quote, currentUser }) {
  const disabled =
    !isAwaitingReply(quote.get("incoming_quote_line_items").toJS()) ||
    quote.get(PORTAL_PURCHASE);

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open} disabled={disabled}>
          <Icon name="envelope-o" fixed />
          &nbsp;Send Request For Quote
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Send Request for Quote</h4>
            </Header>
            <Form close={close} quote={quote} currentUser={currentUser} />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

Send.propTypes = {
  quote: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(Send);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/Send/Send.jsx